import TableField from "@/components/common/table-field/TableField.vue";

export default {
    name: 'Invoice',
    components: {
        TableField
    },

    data() {
        return {
            loading: false,
            invoices: [],
            params: {
                page: 1,
                pageSize: this.getPageSize(),
                total: 0,
                sort_column: null,
                sort_direction: null,
                search: this.getSearch(),
                filter: {
                    date: this.getDate()
                }
            }
        }
    },

    computed: {
        companyId () {
            return this.$store.state.companyId;
        },

        columns() {
            return [
                { title: this.$t('invoices.nr'), key: "billApproveNumber", sortable: true, wrap: false },
                { title: this.$t('invoices.period'), key: "period", sortable: true, wrap: false },
                { title: this.$t('invoices.pdf'), key: "pdf", sortable: true },
                { title: this.$t('invoices.contract'), key: "contractNumber", sortable: true, wrap: false },
                { title: this.$t('invoices.count-vehicles'), key: "objectCount", sortable: true },
                { title: this.$t('invoices.discount'), key: "discountRate", sortable: true },
                { title: this.$t('invoices.discount-sum'), key: "discount", sortable: true },
                { title: this.$t('invoices.price'), key: "discountPrice", sortable: true },
                { title: this.$t('invoices.vat'), key: "vat", sortable: true },
                { title: this.$t('invoices.vat-price'), key: "vatPrice", sortable: true },
                { title: this.$t('invoices.total-price'), key: "totalPrice", sortable: true }
            ]
        }
    },

    methods: {
        getPageSize() {
            const pageSize = localStorage.getItem('invoice-page-size');
            return pageSize ? Number(pageSize) : 20;
        },

        getDate() {
            const date = localStorage.getItem('invoice_params_date');
            return date ? date : null;
        },

        getSearch() {
            const search = localStorage.getItem('invoice_params_search');
            return search ? search : null;
        },

        async populateData() {
            this.loading = true;
            try {
                const params = this.params;
                params.companyId = this.companyId;
                const response = await this.ApiRequest.requestAsync(
                    `billing/invoices`,
                    this.ApiRequest.REQUEST_POST,
                    params,
                    'invoices-search',
                    true
                );

                if (!response || response.error || response.canceled) return;
                const { data, pagination } = response;
                this.invoices = this.BasicHelper.cloneObject(data.invoices);
                this.params = {
                    ...this.params,
                    ...pagination
                }
            } finally {
                this.loading = false;
            }
        },

        changeDate(value) {
            if (value != null) {
                localStorage.setItem('invoice_params_date', value);
            } else {
                localStorage.removeItem("invoice_params_date");
            }
            this.params.filter.date = value;

            this.populateData();
        },

        async downloadFile(invoiceId, lang) {
            this.loading = true;
            try {
                const result = await this.ApiRequest.requestAsync(
                    `billing/download/invoice`,
                    this.ApiRequest.REQUEST_DOWNLOAD,
                    { invoiceId, lang },
                    'download-invoice',
                    true
                );

                if (result.error && !result.canceled) {
                    console.error('Error download', result);
                }
            } catch (error) {
                if (!error?.canceled) {
                    console.error('Error download:', error);
                }
            } finally {
                this.loading = false;
            }
        }
    },

    beforeMount() {
        this.populateData();
    },

    watch: {
        companyId() {
            this.populateData();
        }
    }
}
